import React from 'react'

import { CircleCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { oneOf } from 'prop-types'

import { iconSize, MODE } from 'Pods/LazyLoaded/AiSignInModal/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function SuccessStep({ mode }) {
  const t = useTranslation()
  const subtitle = mode === MODE.LOGIN
    ? t('signIn.success.loginSubtitle')
    : t('signIn.success.signupSubtitle')

  return (
    <div className="ai-sign-in-modal__success">
      <span className="ai-sign-in-modal__success-icon">
        <Icon svgComponent={CircleCheck} size={iconSize} notSpaced />
      </span>
      <div className="ai-sign-in-modal__header-group ai-sign-in-modal__header-group--center">
        <p className="ai-sign-in-modal__title cgt-heading-300">{t('signIn.success.title')}</p>
        <p className="ai-sign-in-modal__subtitle cgt-body-md">{subtitle}</p>
      </div>
    </div>
  )
}

SuccessStep.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]).isRequired,
}

export default SuccessStep
